/** @format */
import { ImageLoader } from 'next/legacy/image';
import qs from 'qs';

import {
    CLOUDFLARE_IMAGE_QUALITY,
    CLOUDFLARE_RESIZE_SERVICE_PATH,
} from '@toucan/client/global/cloudflare';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CloudflareResizeServiceOptions = {
    width: number;
    src: string;
    format?: string;
};

export const getCloudflareResizeServiceUrl = ({
    width,
    src,
    format = 'auto',
}: CloudflareResizeServiceOptions) => {
    const options = {
        width,
        quality: CLOUDFLARE_IMAGE_QUALITY,
        format,
    };

    // e.g: https://www.mpb.com/cdn-cgi/image/width=99,quality=60,format=auto/media-service/1234.jpg
    return `${CLOUDFLARE_RESIZE_SERVICE_PATH}${qs.stringify(options, {
        delimiter: ',',
    })}${src}`;
};

export const cloudflareLoader: ImageLoader = ({ width, src }) =>
    getCloudflareResizeServiceUrl({ width, src });
